import TitleUi from '@components/common/TitleUi'
import SubDetalles from './subdetalles'
import _ from 'lodash';

const DetalleCard = ({
    titulo,
    descripcion,
    detalleItems
}) => {
    const _detalleItems = _.orderBy(detalleItems, ['orden'], ['asc']);

    return (
        <div>
            <TitleUi titulo={titulo} descripcion_corta={descripcion} h2/>
            <SubDetalles data={_detalleItems} />
        </div>
    )
}

export default DetalleCard